import React from 'react'

export interface SingleChoiceWidgetProps {
  options: string[]
  value: string | null
  onChange: (value: string) => void
  disabled?: boolean
}

export function SingleChoiceWidget({
  options,
  value,
  onChange,
  disabled = false,
}: SingleChoiceWidgetProps): React.ReactElement {
  return (
    <div
      role="radiogroup"
      aria-label="Select one option"
      data-testid="single-choice-widget"
      className="flex flex-col gap-2"
    >
      {options.map((option) => {
        const isSelected = value === option

        return (
          <label
            key={option}
            className={[
              'flex items-center gap-3 px-4 py-3 rounded-lg border text-sm font-medium font-sans transition-colors cursor-pointer',
              'focus-within:ring-2 focus-within:ring-brand-500 focus-within:ring-offset-2',
              isSelected
                ? 'border-brand-500 bg-brand-50 text-brand-700'
                : 'border-neutral-300 bg-neutral-0 text-neutral-700 hover:border-brand-300 hover:bg-neutral-50',
              disabled ? 'opacity-50 cursor-not-allowed' : '',
            ].join(' ')}
            data-testid={`single-choice-option-${option}`}
          >
            <input
              type="radio"
              name="single-choice"
              value={option}
              checked={isSelected}
              onChange={() => onChange(option)}
              disabled={disabled}
              className="sr-only"
              aria-checked={isSelected}
            />
            <span
              aria-hidden="true"
              className={[
                'flex items-center justify-center w-5 h-5 rounded-full border-2 shrink-0 transition-colors',
                isSelected
                  ? 'border-brand-500 bg-brand-500'
                  : 'border-neutral-400 bg-neutral-0',
              ].join(' ')}
            >
              {isSelected && (
                <span className="w-2 h-2 rounded-full bg-neutral-0" />
              )}
            </span>
            <span>{option}</span>
          </label>
        )
      })}
    </div>
  )
}
